module.exports = __webpack_public_path__ + "static/media/scones.b538be90.jpg";